import * as actionType from './DataCenterAutomationActionType';

export const exportDocumentMappingRequest = (automationID) => ({
    type: actionType.EXPORT_DOCUMENT_MAPPING_REQUEST,
    payload: automationID,
});

export const exportDocumentMappingSuccess = (data) => ({
    type: actionType.EXPORT_DOCUMENT_MAPPING_SUCCESS,
    payload: data,
});

export const exportDocumentMappingFailure = (error) => ({
    type: actionType.EXPORT_DOCUMENT_MAPPING_FAILURE,
    payload: error,
});

export const dataCenterAutomationSaveBulkRequest = (data) => ({
    type: actionType.DATA_CENTER_AUTOMATION_SAVE_BULK_REQUEST,
    payload: data,
});

export const dataCenterAutomationSaveBulkSuccess = (data) => ({
    type: actionType.DATA_CENTER_AUTOMATION_SAVE_BULK_SUCCESS,
    payload: data,
});

export const dataCenterAutomationSaveBulkFailure = (error) => ({
    type: actionType.DATA_CENTER_AUTOMATION_SAVE_BULK_FAILURE,
    payload: error,
});

export const dataCenterAutomationListRequest = (data) => ({
    type: actionType.DATA_CENTER_AUTOMATION_LIST_REQUEST,
    payload: data,
});

export const dataCenterAutomationListSuccess = (data) => ({
    type: actionType.DATA_CENTER_AUTOMATION_LIST_SUCCESS,
    payload: data,
});

export const dataCenterAutomationListFailure = (error) => ({
    type: actionType.DATA_CENTER_AUTOMATION_LIST_FAILURE,
    payload: error,
});

export const documentMappingsRequest = (data) => ({
    type: actionType.DOCUMENT_MAPPINGS_REQUEST,
    payload: data,
});

export const documentMappingsSuccess = (data) => ({
    type: actionType.DOCUMENT_MAPPINGS_SUCCESS,
    payload: data,
});

export const documentMappingsFailure = (error) => ({
    type: actionType.DOCUMENT_MAPPINGS_FAILURE,
    payload: error,
});

export const folderPathTestConnectionRequest = (data) => ({
    type: actionType.FOLDER_PATH_TEST_CONNECTION_REQUEST,
    payload: data,
});

export const folderPathTestConnectionSuccess = (data) => ({
    type: actionType.FOLDER_PATH_TEST_CONNECTION_SUCCESS,
    payload: data,
});

export const folderPathTestConnectionFailure = (error) => ({
    type: actionType.FOLDER_PATH_TEST_CONNECTION_FAILURE,
    payload: error,
});
